import { iconSize } from "../../tokens";
import type { TypographyProps } from "../typography";
import type { TagSize, TagVariant } from "./types";

type TagTextColor = NonNullable<TypographyProps["color"]>;

// Filled and outline Tags share label and icon colours, as Figma binds them;
// the icon takes the label's colour unless `leadingIconColor` is given
export const tagTextColor: Record<TagVariant, TagTextColor> = {
  primary: "brand-on-primary-surface",
  success: "system-success-on-surface",
  danger: "system-danger-on-surface",
  info: "system-info-on-surface",
  warning: "system-warning-on-surface",
  neutral: "neutral-foreground-intermediate",
};

// Typography per size, at Medium as Figma draws every Tag label: 10/14, 12/16
// and 14/20, from 768px 12/16, 14/20 and 16/24 (designer feedback, 2026-10-28)
export const tagTypography = {
  sm: "caption-md-medium",
  md: "body-sm-medium",
  lg: "body-md-medium",
} as const;

// Figma draws 12/16/16 on mobile and desktop alike, so these are the token
// values, not size keys (a key would step up on desktop web)
export const tagIconSize: Record<TagSize, number> = {
  sm: iconSize.xs,
  md: iconSize.sm,
  lg: iconSize.sm,
};
